<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title=" Kemasukan Cara Bayaran">
            <w-flex class="mt3">
                <div class="xs6"> 
                    <w-input label="Kod" v-model="cari.kod"> </w-input>
                </div>
                <div class="xs6"> 
                    <w-input label="Keterangan" v-model="cari.keterangan"> </w-input>
                </div>
                
            </w-flex>
          
            
             <div class="mt2 text-right">
                
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                   <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
             </div>
           
            <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                  <template v-if="form.id > 0">
                    Kemaskini
                  </template>
                  <template v-else>
                    Tambah
                  </template>
                     Cara Bayaran
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submit" @success="success">   
                        <w-flex justify-space-between class="mb4">
                           <z-input label="Kod *" v-model="form.kod" name="kod" :validators="[validators.required]" />
                            &nbsp;&nbsp;
                            <z-input label="Keterangan *" v-model="form.keterangan" name="Keterangan" :validators="[validators.required]" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                      Status
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.status"></w-switch>
                                </div>
                            </div>

                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                      Is Terimaan
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.is_terimaan"></w-switch>
                                </div>
                            </div>

                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                      Is Bayaran
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.is_bayaran"></w-switch>
                                </div>
                            </div>

                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                      Is Terminal
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.is_terminal"></w-switch>
                                </div>
                            </div>
                        </w-flex>

                        <w-flex justify-space-between class="mb4">
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                      Is Bank
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.is_bank"></w-switch>
                                </div>
                            </div>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                      Is Dokumen
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.is_dokumen"></w-switch>
                                </div>
                            </div>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                      Is Cek
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.is_cek"></w-switch>
                                </div>
                            </div>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                </div>
                            </div>
                        </w-flex>
                      
                        <div class="w-card__content content-hardcode">                
                          <table class="table-dashboard" width="100%">
                           <thead>
                            <tr>
                                <td >Keterangan *</td>
                                <td><w-icon class="mr1" @click="addItem">fal fa-plus</w-icon></td>
                            </tr>
                             </thead>
                            
                                <tr v-for="dt, index in form.trans_type">
                                    <td >
                                        <z-input label="Keterangan *" v-model="dt.keterangan" name="Keterangan" :validators="[validators.required]" />
                                    </td>
                                    
                                    <td><w-icon class="mr1" @click="removeItem(index)">fal fa-trash</w-icon></td>
                                </tr>
                        </table>
                      </div>
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
                    <template v-if="total_debit == total_kredit">
                        <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">{{form.saveButton}}</w-button>
                    </template>
                    <template v-else>
                        <w-button class="ml1" :loading="dialog.loading" :disabled="true" >{{form.saveButton}}</w-button>
                    </template>
                    
                </template>
            </w-dialog>
            <br><br>

            <z-table ref="tbluser" title="Senarai Cara Bayaran" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                <template #button>
                    <w-button dark class="indigo-dark2--bg ml1" @click="add()">
                        <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                    </w-button>
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                 <template #item-cell.status="{ item, label, header, index }">
                    <template v-if="item.status == 1">
                        AKTIF
                    </template>
                    <template v-else>
                        TIDAK AKTIF
                    </template>
                </template>

                <template #item-cell.is_terimaan="{ item, label, header, index }">
                    <template v-if="item.is_terimaan == 1">
                        YA
                    </template>
                    <template v-else>
                        TIDAK
                    </template>
                </template>

                <template #item-cell.is_bayaran="{ item, label, header, index }">
                    <template v-if="item.is_bayaran == 1">
                        YA
                    </template>
                    <template v-else>
                        TIDAK
                    </template>
                </template>

                <template #item-cell.is_terminal="{ item, label, header, index }">
                    <template v-if="item.is_terminal == 1">
                        YA
                    </template>
                    <template v-else>
                        TIDAK
                    </template>
                </template>

                <template #item-cell.is_bank="{ item, label, header, index }">
                    <template v-if="item.is_bank == 1">
                        YA
                    </template>
                    <template v-else>
                        TIDAK
                    </template>
                </template>

                 <template #item-cell.is_dokumen="{ item, label, header, index }">
                    <template v-if="item.is_dokumen == 1">
                        YA
                    </template>
                    <template v-else>
                        TIDAK
                    </template>
                </template>

                <template #item-cell.is_cek="{ item, label, header, index }">
                    <template v-if="item.is_cek == 1">
                        YA
                    </template>
                    <template v-else>
                        TIDAK
                    </template>
                </template>

               

                <template #item-cell.trans="{ item, label, header, index }">
                    <template v-for="dt, index in item.trans_type">
                            <div>{{dt.keterangan}} </div>    
                    </template>
                </template>
               
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <!-- <w-icon tile @click="show(item)">fal fa-eye</w-icon> -->
                        &nbsp;&nbsp;
                        <w-icon tile @click="edit(item)">fal fa-pencil</w-icon>
                        &nbsp;&nbsp;
                        <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                       
                    </w-flex>
                </template>
            </z-table>
           
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_utiliti+'cara_bayaran',
        reload: true,
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Utiliti', route: '/utiliti' },
            { label: 'Cara Bayaran', route: '/utiliti/cara_bayaran' }
          ],
       
        form :{},
      
        tabs: [
            { title: 'Butiran', content: '' },
            // { title: 'Jejak Audit', content: '' },
        ],
        cari : {kod: '', keterangan: ''},
       
       
        dialogProfil: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          form: {nama: '', email: ''}
        },
    }
         
  },
  methods: {

    search() {
      var url = window.route('utiliti.cara_bayaran.index')+'?kod='+this.cari.kod+'&keterangan='+this.cari.keterangan;
      this.$inertia.visit(url, { preserveScroll : true})
    },

    reset(){
      this.cari =  {kod: '', keterangan: ''}
      this.search()
    },

    

    addItem() {
        this.form.trans_type.push( {keterangan : null});
    },

    removeItem(index) {
        this.form.trans_type.splice(index, 1);
    },

    

    add() {
            this.form = {
                id : null,
                kod : null,
                keterangan : null,
                is_terimaan : null,
                is_terminal : null,
                is_dokumen : null,
                is_bank : null,
                is_cek : null,
                is_bayaran : null,
                status : null,
                trans_type : [
                    { keterangan : null},
                ]
            }
            this.dialog.show = true
            this.form.saveButton = "Simpan"
            this.total_kredit = 0
            this.total_debit = 0
    },

    edit(idx) {
        this.form = idx
        this.form.saveButton = "Kemaskini"
        this.dialog.show = true
    },

    show(idx) {
        this.form = idx
        this.form.saveButton = "Kemaskini"
        this.modal.show = true
    },
    
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 900
  
  },
    
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
